import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import MainMenu from '../../../modules/menu/mainMenu/MainMenu'
import ExpiredContractMessage from '../../messenger/ExpiredContractMessage'
import PendingBillingMessage from '../../messenger/PendingBillingMessage'
import ProcessesFeatureMessage from '../../messenger/ProcessesFeatureMessage'

const SideMenuPageTemplate = ({ children, bgColor }) => {
  return (
    <Grid justify="stretch" align="stretch" height="100%" direction="row-reverse" bgColor={bgColor}>
      <Col flex={1} align="stretch" justify="flex-start" scroll>
        <ExpiredContractMessage />
        <PendingBillingMessage />
        <ProcessesFeatureMessage />
        {children}
      </Col>

      <Col width="4rem">
        <MainMenu />
      </Col>
    </Grid>
  )
}

export default SideMenuPageTemplate
